import { UrlPart } from './UrlPart';

export const AuthStepItemType = {
  Password: 'Password',
  Text: 'Text',
  TextArea: 'TextArea',
  Select: 'Select',
  Email: 'Email',
  Url: 'Url',
  Html: 'Html',
  InfoBlock: 'InfoBlock',
  Snippet: 'Snippet',
} as const;

export type AuthStepItemType =
  (typeof AuthStepItemType)[keyof typeof AuthStepItemType];

type Tooltip = {
  text: string;
};

type Help = {
  text: string;
  link: string;
};

type PasswordStep = {
  type: typeof AuthStepItemType.Password;
  name: string;
  required: boolean;
  tooltip?: Tooltip;
  help?: Help;
};

type TextStep = {
  type: typeof AuthStepItemType.Text;
  name: string;
  required: boolean;
  description?: string;
  placeholder?: string;
  tooltip?: Tooltip;
  help?: Help;
};

type TextAreaStep = {
  type: typeof AuthStepItemType.TextArea;
  name: string;
  required: boolean;
  description?: string;
  placeholder?: string;
  tooltip?: Tooltip;
  help?: Help;
};

type EmailStep = {
  type: typeof AuthStepItemType.Email;
  name: string;
  required: boolean;
  tooltip?: Tooltip;
  help?: Help;
};

type HtmlStep = {
  type: typeof AuthStepItemType.Html;
  html: string;
  tooltip?: Tooltip;
  help?: Help;
};

type InfoBlockStep = {
  type: typeof AuthStepItemType.InfoBlock;
  message: string;
  link?: {
    text: string;
    destination: string;
  };
  tooltip?: Tooltip;
};

type SnippetStep = {
  type: typeof AuthStepItemType.Snippet;
  snippet: string;
  description?: string;
  tooltip?: Tooltip;
  help?: Help;
};

type SelectStep = {
  type: typeof AuthStepItemType.Select;
  name: string;
  options: Array<{ label: string; value: string }>;
  required: boolean;
  tooltip?: Tooltip;
  help?: Help;
};

export type UrlStep = {
  type: typeof AuthStepItemType.Url;
  name: string;
  parts: Array<UrlPart>;
  required: boolean;
  placeholder?: string;
  tooltip?: Tooltip;
  help?: Help;
};

export type AuthStepItem =
  | PasswordStep
  | TextStep
  | TextAreaStep
  | EmailStep
  | HtmlStep
  | InfoBlockStep
  | UrlStep
  | SelectStep
  | SnippetStep;

export type { Tooltip, Help };
